import { lazy } from "react";
import { historicalInfoSVG, activeServicesSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "transmission" */ './components/EntryPoint'));
const ActiveLoader = lazy(() => import(/* webpackChunkName: "transmissionLoader" */ './components/ActiveServicesLoader'));
const ActiveDetail = lazy(() => import(/* webpackChunkName: "transmissionLoader" */ './components/ActiveDetail/ActiveDetails/ActiveDetails.container'));

export const defaultPath = '/activeServices';

export const innerRoutes = [
    {
        path: `${defaultPath}/detail/:id`,
        Component: ActiveDetail,
        exact: true,
        icon: activeServicesSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    },
    {
        path: `${defaultPath}/`,
        Component: ActiveLoader,
        exact: true,
        icon: activeServicesSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    }
];

const ActiveServices = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: activeServicesSVG,
    title: {
        key: 'Gestión de renovaciones',
        plural: false
    },
    subTitle: {
        key: 'Visualiza y gestiona las renovaciones',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default ActiveServices;
